var map = {
	"./alert.svg": "bfa8",
	"./arrow_back.svg": "a91e",
	"./arrow_down.svg": "482b",
	"./arrow_down_blue.svg": "110d",
	"./arrow_down_white.svg": "eaca",
	"./arrow_r.svg": "96f9",
	"./back-white.svg": "08d6",
	"./bell-blue.svg": "37c1",
	"./bell.svg": "4bf1",
	"./blocked-blue.svg": "c18a",
	"./blocked.svg": "468e",
	"./check.svg": "6561",
	"./circ-close.svg": "e2ff",
	"./clock1.svg": "fc20",
	"./close-blue.svg": "d9b0",
	"./close-sm-blue.svg": "a228",
	"./close-sm.svg": "b98e",
	"./close-white.svg": "c53e",
	"./close.svg": "58a4",
	"./doc-calander-white.svg": "488f",
	"./doc-calander.svg": "56b7",
	"./doctor-fill.svg": "4c7d",
	"./filters.svg": "3eb5",
	"./glob-white.svg": "7130",
	"./glob.svg": "533d",
	"./ic-arrow.svg": "86d6",
	"./ic-card.svg": "878e",
	"./ic-date-black.svg": "092b",
	"./ic-date.svg": "a9d4",
	"./ic-file.svg": "fa99",
	"./ic-list.svg": "8e6d",
	"./ic-pdf.svg": "ae41",
	"./ic-pen-white.svg": "a826",
	"./ic-pen.svg": "8991",
	"./ic-phone-white.svg": "b060",
	"./ic-phone.svg": "cb71",
	"./ic-print.svg": "45e6",
	"./loader-blue.svg": "860f",
	"./loader.svg": "9f35",
	"./logo-myMedical.svg": "a34d",
	"./logo.svg": "1ea0",
	"./ok-green.svg": "a0fa",
	"./ok-light.svg": "e9f2",
	"./ok-white.svg": "c2ce",
	"./ok-yellow.svg": "5812",
	"./ok.svg": "4766",
	"./pen-blue.svg": "df33",
	"./scheduling.svg": "5b19",
	"./search.svg": "c6a2",
	"./tab-block.svg": "7e04",
	"./tab-edit.svg": "ad9b",
	"./tab-list.svg": "c3bd",
	"./thank.svg": "e4be",
	"./time-settings.svg": "11ec",
	"./trash-black.svg": "cf76",
	"./trash.svg": "47b8",
	"./upload.svg": "5474",
	"./whatsapp.svg": "0bb3",
	"./wts-blue.svg": "9548"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57ae";